import { render, staticRenderFns } from "./company.vue?vue&type=template&id=590ec14c&scoped=true&"
import script from "./company.vue?vue&type=script&lang=js&"
export * from "./company.vue?vue&type=script&lang=js&"
import style0 from "./company.vue?vue&type=style&index=0&lang=css&"
import style1 from "./company.vue?vue&type=style&index=1&id=590ec14c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590ec14c",
  null
  
)

export default component.exports